<template>
    <div class="w-full">
        <div v-for="product in softwareCart" :key="product">
            <div class="flex justify-between pb-1">
                <div class="leading-0"> 
                    <div class="font-semibold">{{product.name}}</div>
                    <div>{{ renewalsPersistedVariables.jsonContent.text.startingAt }} {{productPrices[product.name].unitPrice}}{{paymentType !== "upfront" ? `/${renewalsPersistedVariables.jsonContent.text[paymentType]}` : '' }}</div>
                </div>
            
            <QuantityToggle @input="event => setKey(product, event)" :default="product.adjusted_quantity" :renewalFlow="true" :max="product.quantity" :min="0" :maxedOut="false" :productKeyOverride="product.product_code" />
            </div>
        </div>
        <Dropdown v-model="firstDropdownAnswer" class="pt-1" v-if="showDownsizeDropdown" :step="generateFirstStep()" required=true />
        <Dropdown v-model="secondDropdownAnswer" v-if="showDownsizeDropdown && firstDropdownAnswer?.valid" class="pt-2" :step="generateSecondStep()" required=true />
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import QuantityToggle from '../../utils/quantity-toggle'
import { SFDCPaymentTypeToVariableName } from '../../../../corpweb_globals'
import Dropdown from '../webstore/Dropdown.vue';
import { analyticsTrack } from '../../../plugins/segment';
export default {
    props: ['step', 'showButton', 'value', 'productPrices'],
    components: {
        QuantityToggle, 
        Dropdown
    },
    data() {
        return {
            adjustedQuantities: {},
            showDownsizeDropdown: false,
            firstDropdownAnswer: {},
            secondDropdownAnswer: {}
        }
    },
    computed: {
        ...mapGetters(['applicationVersion', 'typeOfRenewal', 'productSource']),
        ...mapGetters('shoppingCart', [
            'hardwareCart',
            'softwareCart',
            'productCostsInfo',
            'cablesInCartCount',
            'softwareMap'
        ]),
        ...mapGetters('checkout', ['selectedPaymentType', 'accountId', 'opptyId']),
        ...mapGetters('content', ['checkoutSharedContent', 'renewalsPersistedVariables']),
        paymentType() {
            return SFDCPaymentTypeToVariableName[this.selectedPaymentType];
        },
    },
    methods: {
        setKey(product, quantity){
            this.adjustedQuantities[product.opportunity_line_item_number] = quantity
            this.$emit('input', {'value': this.adjustedQuantities, 'valid': true})
            //temp- move to function
            if(this.quantitiesChanged()){
                this.showDownsizeDropdown = true
            }
            else{
                this.$emit('clearFields');
                this.firstDropdownAnswer = {}
                this.secondDropdownAnswer = {}
                this.showDownsizeDropdown = false 
            }
        },
        quantitiesChanged(){
            for(let i = 0; i < this.softwareCart.length; ++i){
                let key = this.softwareCart[i];
                if(key.opportunity_line_item_number in this.adjustedQuantities && this.adjustedQuantities[key.opportunity_line_item_number] < key.quantity){
                    return true;
                }
            }
            return false;
        },
        generateFirstStep(){
            return {
                'label': this.renewalsPersistedVariables.jsonContent.dropdowns.questions.downsizing, 
                'valueList': [
                    {
                        name: this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeReasons.adoption,
                        value: 'Adoption',
                    },
                    {
                        name: this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeReasons.businessChanges,
                        value: 'Business Changes',
                    },
                    {
                        name: this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeReasons.commercialTerms,
                        value: 'Commercial Terms',
                    },
                    {
                        name: this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeReasons.customerService,
                        value: 'Customer Service',
                    },
                    {
                        name: this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeReasons.easeOfDoingBusiness,
                        value: 'Ease of Doing Business',
                    },
                    {
                        name: this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeReasons.productFit,
                        value: 'Product Fit',
                    },
                    {
                        name: this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeReasons.productTechnicalIssues,
                        value: 'Product Technical Issues',
                    },
                ]
            }
        },
        generateSecondStep(){
            return {'label': this.renewalsPersistedVariables.jsonContent.dropdowns.questions.tellUsMore, 'valueList': this.renewalsPersistedVariables.jsonContent.dropdowns.downsizeSubReasons[this.firstDropdownAnswer.value]}
        }
    },
    mounted () {
        let productToQuantitesMapping = {};
        this.softwareCart.forEach((license) => {
            if (license.product_code in productToQuantitesMapping){
                productToQuantitesMapping[license.product_code] += license.adjusted_quantity;
            } else {
                productToQuantitesMapping[license.product_code] = license.adjusted_quantity;
            }
        });
        analyticsTrack("Edit Quantity Button Clicked", {"accountId": this.accountId, "opptyId": this.opptyId, "quantities": productToQuantitesMapping, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
    },
    watch: {
        firstDropdownAnswer:{
            deep: true,
            handler(){
                this.$emit('addField', 'downsizeReason', this.firstDropdownAnswer);
                this.secondDropdownAnswer = {};
            }
        },
        secondDropdownAnswer:{
            deep: true,
            handler(){
                this.$emit('addField', 'downsizeSubReason', this.secondDropdownAnswer);
            }
    }
    }

}
</script>

<style lang="scss" scoped>
:deep(.input-number){
    min-width: 50px;
}
</style>